/*
 * @Descripttion: 为了保证重定向到某个菜单时，菜单可以正确标识，这里增加了该方法来定位水平菜单和左侧菜单
 * @version: v1.0.0
 * @Author: cyf
 * @Date: 2020-10-13 17:21:27
 * @LastEditors: cyf
 * @LastEditTime: 2020-10-14 09:46:03
 */



/**
 * @name: 路由重定向并将菜单定位到匹配的路由位置
 * @msg: 
 * @param {that:当前文档的this指向,path:要跳转的路由地址(与router中配置的要一致),query:url参数同router.push中的query参数,params:同router.params参数} 
 * @return {type} 
 */
function redirect(that, path, query = null, params = null) {
    //跳转到指定路径
    that.$router.push({ path: path, query: query, params: params });
    //获取与要跳转的路径相关联的所有菜单项
    let menuArr = getRelativeMenu(that, path);
    //判断要跳转到的路由是否为左侧菜单
    let match = menuArr.filter(item => { return item.IsDropDown == "0" });
    if (match.length > 0) {
        //要跳转的路径是左侧菜单时，显示左侧菜单，先定位水平菜单,再定位左侧菜单位置
        that.$store.commit("saveLeftMenuVisible", true);
        that.$store.commit("saveLeftMenuPID", match[0].ID);
        //that.$store.commit("setCurMenu", match[0].Url);
        that.$store.commit("saveCurLeftMenu", path);
    } else {
        //非左侧菜单时，隐藏左侧菜单，并定位到水平菜单位置
        that.$store.commit("saveLeftMenuVisible", false);
        that.$store.commit("setCurMenu", path);
    }
}

/**
 * @name: 
 * @msg: 获取与path相关联的菜单信息，包含path的菜单信息和其所有父菜单信息，向上追溯到pid为0的菜单
 * @param {type} 
 * @return {type} 
 */
function getRelativeMenu(that, path) {
    let menuArr = [];
    let match = that.$store.state.menuData.filter(item => { return item.Url == path; });
    if (match.length > 0) {
        menuArr = menuArr.concat(match);
        menuArr = getMatchMenu(that, match[0].ParentID, menuArr);
    }
    return menuArr;
}

function getMatchMenu(that, pid, menuArr) {
    if (pid != "0") {
        let match = that.$store.state.menuData.filter(item => { return item.ID == pid; });
        if (match.length > 0) {
            menuArr = menuArr.concat(match);
            getMatchMenu(that, match[0].ParentID, menuArr);
        }
    }
    return menuArr;
}
export default {
    /**
     * @name: 路由重定向并将菜单定位到匹配的路由位置
     * @msg: 
     * @param {that:当前文档的this指向,path:要跳转的路由地址(与router中配置的要一致),query:url参数同router.push中的query参数,params:同router.params参数} 
     * @return {type} 
     */
    redirect: function (that, path, query = null, params = null) {
        return redirect(that, path, query, params);
    }
}